import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import { semanticColors } from '@/common/styles/colorTokens';
import { sizes } from '@/common/styles/sizes';
import { typography } from '@/common/styles/typographyTokens';
import { cleanCompanyName } from '@/common/utils/commonUtil';

interface AvatarProps {
  src?: string;
  alt: string;
  sizes?: 'md' | 'lg' | 'xl' | 'xxl';
  isUser?: boolean;
}

const Avatar = ({ src, alt, sizes = 'md', isUser = true }: AvatarProps) => {
  const [imgError, setImgError] = useState(false);
  const showInitial = !src || imgError;

  const altChar = cleanCompanyName(alt).charAt(0).toUpperCase();

  useEffect(() => {
    setImgError(false);
  },[src])

  return (
    <AvatarContainer 
      $sizes={sizes} 
      $isUser={isUser}
      $showInitial={showInitial}
    >
      {!showInitial && (
        <AvatarImage
          src={src}
          onError={() => setImgError(true)}
          $sizes={sizes}
        />
      )}
      {showInitial && (
        <AvatarInitial $sizes={sizes}>
          {altChar}
        </AvatarInitial>
      )}
    </AvatarContainer>
  );
};

const AvatarContainer = styled.div<{
  $sizes: 'md' | 'lg' | 'xl' | 'xxl';
  $isUser: boolean;
  $showInitial: boolean;
}>`
  width: ${props => props.$sizes === 'md' ? sizes.avatar[2] : props.$sizes === 'lg' ? sizes.avatar[3] : props.$sizes === 'xl' ? sizes.avatar[4] : props.$sizes === 'xxl' ? sizes.avatar[7] : sizes.avatar[6]};
  height: ${props => props.$sizes === 'md' ? sizes.avatar[2] : props.$sizes === 'lg' ? sizes.avatar[3] : props.$sizes === 'xl' ? sizes.avatar[4] : props.$sizes === 'xxl' ? sizes.avatar[7] : sizes.avatar[6]};
  border-radius: ${props => props.$isUser ? sizes.radius.full : sizes.radius.lg};
  background-color: ${semanticColors.background.secondary};
  border: 1px solid ${semanticColors.border.primary};
  overflow: hidden;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
`;

const AvatarImage = styled.img<{
  $sizes: 'md' | 'lg' | 'xl' | 'xxl';
}>`
  width: 100%;
  height: 100%;
  object-fit: cover;
`;

const AvatarInitial = styled.span<{
  $sizes: 'md' | 'lg' | 'xl' | 'xxl';
}>`
  ${props => props.$sizes === 'md' ? typography.heading.h6 : props.$sizes === 'lg' ? typography.heading.h5 : props.$sizes === 'xl' ? typography.heading.h4 : typography.heading.h1}
  color: ${semanticColors.text.primary};
`;

export default Avatar;
